/* SS Entries Cover — VIP-style mobile carousel for a Collection tabs section.
   Phones only (≤749px): the theme's Flickity carousel is switched off for that one section and the
   same slides become a cover-flow (center card in front, neighbours scaled back on each side),
   with tier tabs that pin while scrolling and dots. Desktop keeps the theme's Flickity.
   The product cards themselves are untouched. Config: .ssec-config inside the section. */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  function q(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function makeTabs(sec, grid, cards, cfg, onPick) {
    var bar = document.createElement('div');
    bar.className = 'ssec-tabs';
    bar.setAttribute('role', 'tablist');
    var spacer = document.createElement('div');
    spacer.className = 'ssec-tabs-spacer';
    cards.forEach(function (card, i) {
      var name = txt(card.querySelector('.product-card-title'));
      var hero = card.querySelector('.ssen'); // entry count hero (snippets/ss-entries-hero.liquid), when on
      var price = hero ? hero.getAttribute('data-price') : txt(card.querySelector('.price .amount') || card.querySelector('.price')).replace(/\.00\b/, '');
      var entries = hero ? hero.getAttribute('data-entries') : '';
      var flag = txt(card.querySelector('.most-popular'));
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ssec-tab' + (entries ? ' ssec-tab--entries' : '');
      b.setAttribute('role', 'tab');
      b.innerHTML = (flag ? '<span class="ssec-tab__flag"></span>' : '') + '<span class="ssec-tab__name"></span>' +
        (entries ? '<span class="ssec-tab__entries"></span><span class="ssec-tab__sub"></span>' : '<span class="ssec-tab__price"></span>');
      if (flag) b.querySelector('.ssec-tab__flag').textContent = flag;
      b.querySelector('.ssec-tab__name').textContent = name;
      if (entries) {
        b.querySelector('.ssec-tab__entries').textContent = entries;
        b.querySelector('.ssec-tab__sub').textContent = 'Entries'; // just "Entries", centered, no price (Charlie, 10/15)
        b.setAttribute('aria-label', name + ', ' + entries + ' entries for ' + price);
      } else {
        b.querySelector('.ssec-tab__price').textContent = price;
      }
      b.addEventListener('click', function () {
        onPick(i);
        if (bar.classList.contains('is-fixed')) window.scrollTo({ top: spacer.getBoundingClientRect().top + window.pageYOffset - offset() - 8, behavior: 'smooth' });
      });
      bar.appendChild(b);
    });
    grid.parentNode.insertBefore(spacer, grid);
    grid.parentNode.insertBefore(bar, grid);
    var tabs = [].slice.call(bar.children);

    // Sit under the theme's sticky header when it is showing, otherwise at the top of the screen
    var header = document.querySelector('theme-header');
    function offset() {
      if (!header) return 0;
      var r = header.getBoundingClientRect();
      return (r.bottom > 0 && r.top > -2) ? Math.round(r.bottom) : 0;
    }
    var fixed = false, ticking = false, barH = 0, lastTop = -1;
    function pin() {
      ticking = false;
      var want = false, top = offset() + 8;
      if (MQ.matches && cfg.pin) {
        var r = spacer.getBoundingClientRect(), gridR = grid.getBoundingClientRect();
        if (!fixed) barH = bar.offsetHeight;
        want = r.top < top && gridR.bottom > top + barH + 200;
      }
      if (want && top !== lastTop) { bar.style.top = top + 'px'; lastTop = top; }
      if (want === fixed) return;
      fixed = want;
      bar.classList.toggle('is-fixed', fixed);
      spacer.style.height = fixed ? (barH + 14) + 'px' : '0px';
      if (!fixed) { bar.style.top = ''; lastTop = -1; }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(pin); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    pin();
    return {
      set: function (i) { tabs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-selected', j === i ? 'true' : 'false'); }); },
      destroy: function () { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); bar.remove(); spacer.remove(); }
    };
  }

  function buildCover(sec, grid, cards, cfg) {
    var tabs = null, dots = null, current = -1;
    if (cfg.tabs) tabs = makeTabs(sec, grid, cards, cfg, function (i) { go(i, true); });
    if (cfg.dots) {
      dots = document.createElement('div');
      dots.className = 'ssec-dots';
      cards.forEach(function (c, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'ssec-dot';
        d.setAttribute('aria-label', 'Show ' + (txt(c.querySelector('.product-card-title')) || 'entry ' + (i + 1)));
        d.addEventListener('click', function () { go(i, true); });
        dots.appendChild(d);
      });
      grid.parentNode.insertBefore(dots, grid.nextSibling);
    }
    function offsetFor(i) { var c = cards[i]; return c.offsetLeft - (grid.clientWidth - c.offsetWidth) / 2; }
    function mark(i) {
      if (i === current) return;
      current = i;
      cards.forEach(function (c, j) { c.classList.toggle('is-center', j === i); c.classList.toggle('is-before', j < i); c.classList.toggle('is-after', j > i); });
      if (dots) [].forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === i); });
      if (tabs) tabs.set(i);
    }
    // While a tap-driven scroll is travelling, keep the highlight on the tapped card so it does not
    // flick through the cards it passes on the way (e.g. ROOKIE -> PRO passing AMATEUR)
    var lockTo = -1;
    function go(i, smooth) {
      lockTo = smooth ? i : -1;
      mark(i);
      grid.scrollTo({ left: offsetFor(i), behavior: smooth ? 'smooth' : 'auto' });
      if (smooth) { clearTimeout(settleT); settleT = setTimeout(settle, 700); }
    }
    function nearest() {
      var mid = grid.scrollLeft + grid.clientWidth / 2, best = 0, bestD = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    var raf = null, settleT = null, touching = false;
    // Lock: once the strip stops moving (and the finger is up), make sure the front card sits exactly centered
    function settle() {
      settleT = null;
      if (touching || !MQ.matches) return;
      var i = lockTo >= 0 ? lockTo : nearest(), t = offsetFor(i);
      lockTo = -1;
      mark(i);
      if (Math.abs(grid.scrollLeft - t) > 1) grid.scrollTo({ left: t, behavior: 'smooth' });
    }
    function onGridScroll() {
      if (!raf) raf = requestAnimationFrame(function () { raf = null; if (lockTo < 0) mark(nearest()); });
      clearTimeout(settleT);
      settleT = setTimeout(settle, 140);
    }
    grid.addEventListener('scroll', onGridScroll, { passive: true });
    function onTouchStart() { touching = true; lockTo = -1; clearTimeout(settleT); }
    function onTouchEnd() { touching = false; clearTimeout(settleT); settleT = setTimeout(settle, 140); }
    grid.addEventListener('touchstart', onTouchStart, { passive: true });
    grid.addEventListener('touchend', onTouchEnd, { passive: true });
    grid.addEventListener('touchcancel', onTouchEnd, { passive: true });
    // A tap on a side card brings it to the front instead of opening it or adding it to the cart
    function onCardClick(e) {
      var c = e.currentTarget;
      if (!MQ.matches || c.classList.contains('is-center')) return;
      e.preventDefault();
      e.stopPropagation();
      go(cards.indexOf(c), true);
    }
    cards.forEach(function (c) { c.addEventListener('click', onCardClick, true); });
    var start = cfg.start === 'first' ? 0 : cfg.start === 'popular'
      ? Math.max(0, cards.findIndex(function (c) { return !!c.querySelector('.most-popular'); }))
      : Math.floor(cards.length / 2);
    requestAnimationFrame(function () { go(start, false); });
    // Re-center only on a real width change (rotation), not when the iOS URL bar shows/hides
    var lastW = window.innerWidth;
    function onResize() { if (Math.abs(window.innerWidth - lastW) < 2) return; lastW = window.innerWidth; if (MQ.matches) { if (cfg.fit) cfg.fit(); go(current < 0 ? start : current, false); } }
    window.addEventListener('resize', onResize, { passive: true });
    function onLoad() { if (grid.scrollLeft === 0 && start > 0) go(start, false); }
    window.addEventListener('load', onLoad);
    return {
      destroy: function () {
        grid.removeEventListener('scroll', onGridScroll);
        grid.removeEventListener('touchstart', onTouchStart);
        grid.removeEventListener('touchend', onTouchEnd);
        grid.removeEventListener('touchcancel', onTouchEnd);
        clearTimeout(settleT);
        window.removeEventListener('resize', onResize);
        window.removeEventListener('load', onLoad);
        cards.forEach(function (c) { c.removeEventListener('click', onCardClick, true); c.classList.remove('is-center', 'is-before', 'is-after'); });
        if (tabs) tabs.destroy();
        if (dots) dots.remove();
      }
    };
  }

  function setup(cfgEl) {
    var sec = cfgEl.closest('.shopify-section');
    if (!sec || sec.dataset.ssecReady) return;
    var grid = sec.querySelector('slide-show');
    if (!grid) return;
    sec.dataset.ssecReady = '1';
    var cfg = {
      tabs: cfgEl.dataset.tabs === 'true',
      pin: cfgEl.dataset.pin === 'true',
      dots: cfgEl.dataset.dots === 'true',
      start: cfgEl.dataset.start || 'middle'
    };
    var saved = null, cover = null, cards = [];
    // Size the strip from the real screen width and pin its left edge to the screen edge, so "center"
    // is the true middle of the phone (iOS Safari's 100vw and percentage margins can be a few px off)
    function fit() {
      var W = document.documentElement.clientWidth || window.innerWidth;
      sec.style.setProperty('--ssec-vw', (W / 100) + 'px');
      grid.style.removeProperty('margin-left');
      var L = grid.getBoundingClientRect().left;
      if (Math.abs(L) > 0.5) grid.style.setProperty('margin-left', (parseFloat(getComputedStyle(grid).marginLeft) - L) + 'px', 'important');
    }
    function on() {
      if (cover) return;
      var F = window.Flickity, f = F && F.data(grid);
      if (f) { saved = f.options; f.destroy(); }
      cards = q('.carousel__slide', grid);
      if (cards.length < 2) return;
      sec.classList.add('ssec--on');
      // The theme's own collection tab row is an invisible placeholder when there is only one collection;
      // collapse it on phones so the tier tabs sit right under the heading
      var list = sec.querySelector('collection-tabs');
      if (list && list.querySelectorAll('button').length <= 1) sec.classList.add('ssec--one-list');
      // Scale an inner wrapper, never the slide itself: browsers snap to the slide's *transformed* box, so a
      // scaled slide snaps ~17px off center. The slide stays full size and is the clean snap target.
      cards.forEach(function (c) {
        c.classList.add('ssec__card');
        var inner = document.createElement('div');
        inner.className = 'ssec__inner';
        while (c.firstChild) inner.appendChild(c.firstChild);
        c.appendChild(inner);
      });
      cfg.fit = fit;
      fit();
      cover = buildCover(sec, grid, cards, cfg);
    }
    function off() {
      if (!cover) return;
      cover.destroy();
      cover = null;
      sec.classList.remove('ssec--on', 'ssec--one-list');
      cards.forEach(function (c) {
        c.classList.remove('ssec__card');
        var inner = c.querySelector(':scope > .ssec__inner');
        if (inner) { while (inner.firstChild) c.insertBefore(inner.firstChild, inner); inner.remove(); }
      });
      sec.style.removeProperty('--ssec-vw');
      grid.style.removeProperty('margin-left');
      if (saved && window.Flickity) new window.Flickity(grid, saved);
    }
    function apply() { if (MQ.matches) on(); else off(); }
    if (MQ.addEventListener) MQ.addEventListener('change', apply); else MQ.addListener(apply);
    // Wait for the theme to finish building its Flickity carousel, then take over on phones
    var tries = 0;
    (function wait() {
      if (grid.classList.contains('flickity-enabled') || tries++ > 40) apply();
      else setTimeout(wait, 75);
    })();
  }

  function initAll() { q('.ssec-config').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('.ssec-config');
    if (c) setup(c);
  });
})();
